module.exports = __webpack_public_path__ + "static/media/Navigate Theme – Gallery – 2.3135a67d.jpg";